import { render, staticRenderFns } from "./ColumnBase.vue?vue&type=template&id=0000cb69&"
import script from "./ColumnBase.vue?vue&type=script&lang=js&"
export * from "./ColumnBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports